import { CmsApplianceDetailsModelSerialForm } from '../../models/appliance-details-model-serial/cms-appliance-details-model-serial-form.interface';

export const mockCmsApplianceDetailsModelSerialForm: CmsApplianceDetailsModelSerialForm =
  {
    modelNumberField: {
      fieldLabel: 'Model number',
      fieldRequired: true,
    },
    serialNumberField: {
      fieldLabel: 'Serial number',
      fieldRequired: true,
    },
  };
